/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const PayrollData = createAsyncThunk('payroll', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const PayrollSlice = createSlice({

    name: 'payroll',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        handleDataRoles: (state, action) => {
            state.roleList = action?.payload
        } 

    },
    extraReducers: {
        [PayrollData.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [PayrollData.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [PayrollData.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading,handleDataRoles } = PayrollSlice.actions;
export default PayrollSlice.reducer